export const severityClassMap = {
  Medium: "tooltip-medium-dril",
  Informational: "tooltip-Info-dril",
  Info: "tooltip-Info-dril",
  "Not Available": "tooltip-notAvailable-dril",
  High: "tooltip-High-dril",
  Critical: "tooltip-Critical-dril",
  Low: "tooltip-Low-dril",
};

export const getSeverityLabel = (severity) => {
  if (severity === null || severity === undefined || severity === "")
     return "---";

  const mapping = {
    1: "Low",
    "1": "Low",
    2: "Medium",
    "2": "Medium",
    3: "High",
    "3": "High",
  };
  return mapping[severity] || severity;
};
